export default __webpack_public_path__ + "static/media/employe.71e2a562.png";